import { AppState } from 'src';
import { Dispatch, connect } from 'react-redux';
import {
  VendorTradeMaintenanceComponent,
  VendorTradeMaintenanceComponentProperties
} from './vendor-trade-maintenance.component';
import {
  getVendorDetails,
  getVendorBrandCertifications,
  getEligibleBrandCertifications,
  updateVendorBrandCertifications,
  updateVendorCVIExceptions,
  deleteVendorCVIExceptions,
  getVendorCVIExceptions,
  getVendorBrandExceptions,
  deleteVendorBrandExceptions,
  updateVendorBrandExceptions,
  saveVendorTrades,
  updateVendorTrade,
  toggleTradeActivation
} from 'src/vendor/vendor.actions';
import { clearVendor } from '../../vendor.actions';

import { lookupVendor, getTrades } from '../vendor-dashboard/vendor-dashboard.actions';
// import { vendorService } from '@services/VendorService';
import { TradeViewModel } from '@models/Vendor';
import { OptionsViewModel } from '@models/common.models';
import { DynamicSelectIdentifier } from '@common/components';
import FormNames from '@constants/FormNames.enum';
import { actions } from 'react-redux-form';
function mapStateToProps(state: AppState, ownProps: {}): Partial<VendorTradeMaintenanceComponentProperties> {
  return {
    vendorVM: state.vendor.vendorVM,
    tradeOptions: state.vendorMaintenance.tradeOptions,
    vendorZipsVM: state.forms.vendorZipsForm,
    vendorBrandCertifications: state.vendor.vendorBrandCertifications,
    eligibleBrandCertifications: state.vendor.eligibleBrandCertifications || null,
    isLoadingBrandCertifications: state.vendor.isLoadingBrandCertifications,
    eligibleCVIs: state.dynamicSelect.options[DynamicSelectIdentifier.CVIs] || null,
    vendorCVIExceptions: state.vendor.vendorCVIExceptions,
    isLoadingCVIExceptions: state.vendor.isLoadingCVIExceptions,
    vendorBrandExceptions: state.vendor.vendorBrandExceptions,
    isLoadingBrandExceptions: state.vendor.isLoadingBrandExceptions,
    isTogglingTradeActivation: state.vendor.isTogglingTradeActivation,
    loadingVendor: state.vendor.loadingVendor
  };
}

function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: {}
): Partial<VendorTradeMaintenanceComponentProperties> {
  return {
    getVendorDetails: (id: number) => {
      return dispatch(getVendorDetails(id));
    },
    resetTradeMaintenanceForm: (currentTrade: TradeViewModel) => {
      dispatch(actions.reset(FormNames.VendorTradeMaintenance));
      dispatch(
        actions.change(
          `${FormNames.VendorTradeMaintenance}.hourlyAmountOverride`,
          currentTrade.hourlyAmountOverride || ''
        )
      );
      dispatch(
        actions.change(
          `${FormNames.VendorTradeMaintenance}.authorizedAmountOverride`,
          currentTrade.authorizedAmountOverride || ''
        )
      );
      dispatch(actions.change(`${FormNames.VendorTradeMaintenance}.reactivateDate`, currentTrade.reactivateDate));
      dispatch(actions.change(`${FormNames.VendorTradeMaintenance}.deactivateDate`, currentTrade.deactivateDate));
    },
    getTrades: async () => {
      await dispatch(getTrades());
    },

    getBrandCertifications: async (id: number) => {
      await dispatch(getVendorBrandCertifications(id)).then(() => {
        dispatch(getEligibleBrandCertifications());
      });
    },
    updateVendorBrandCertifications: async (vendorId: number, data: OptionsViewModel[]) => {
      await dispatch(updateVendorBrandCertifications(vendorId, data)).then(() =>
        dispatch(getVendorBrandCertifications(vendorId)).then(() => {
          dispatch(getEligibleBrandCertifications());
        })
      );
    },

    getCVIExceptions: (id: number) => {
      return dispatch(getVendorCVIExceptions(id));
    },

    deleteVendorCVIExceptions: async (vendorId: number, data: number[]) => {
      if (data.length > 0) {
        await dispatch(deleteVendorCVIExceptions(vendorId, data)).then(() =>
          dispatch(getVendorCVIExceptions(vendorId))
        );
      }
    },
    updateVendorCVIExceptions: async (vendorId: number, data: number[]) => {
      if (data.length > 0) {
        await dispatch(updateVendorCVIExceptions(vendorId, data)).then(() =>
          dispatch(getVendorCVIExceptions(vendorId))
        );
      }
    },

    getBrandExceptions: (id: number) => {
      return dispatch(getVendorBrandExceptions(id));
    },

    deleteVendorBrandExceptions: async (vendorId: number, data: number[]) => {
      if (data.length > 0) {
        await dispatch(deleteVendorBrandExceptions(vendorId, data)).then(() =>
          dispatch(getVendorBrandExceptions(vendorId))
        );
      }
    },
    updateVendorBrandExceptions: async (vendorId: number, data: number[]) => {
      if (data.length > 0) {
        await dispatch(updateVendorBrandExceptions(vendorId, data)).then(() =>
          dispatch(getVendorBrandExceptions(vendorId))
        );
      }
    },

    saveVendorTrades: async (vendorId: number, vendorTrades: TradeViewModel[]) => {
      if (vendorTrades.length > 0) {
        await dispatch(saveVendorTrades(vendorId, vendorTrades));
      }
    },

    updateVendorTrade: async (vendorId: number, vendorTrade: TradeViewModel) => {
      await dispatch(updateVendorTrade(vendorId, vendorTrade)).then(() => dispatch(getVendorDetails(vendorId)));
    },

    toggleTradeActivation: async (vendorId: number, vendorTradeId: number, activate: boolean) => {
      await dispatch(toggleTradeActivation(vendorId, vendorTradeId, activate)).then(() =>
        dispatch(getVendorDetails(vendorId))
      );
    },

    clearVendor: () => {
      dispatch(clearVendor());
    },
    vendorLookup(value: string, id: number) {
      return lookupVendor(value, id);
    }
  };
}

export const VendorTradeMaintenance = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorTradeMaintenanceComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-trade-maintenance/vendor-trade-maintenance.container.ts